import { c as _c } from "react/compiler-runtime";
import type { CreditCardOffer } from '@cc-shopping/contracts/cross-site/marketplace/types';
import { ApplyNowButton } from 'src/features/product-card/ApplyNowButton';
import type { CtaAnalyticsProps } from 'src/features/product-card/CTA/CtaLink';
export const SmallScreenLearnMore = t0 => {
  const $ = _c(13);
  const {
    creditCardOffer,
    ctaAnalytics
  } = t0;
  const {
    details: t1,
    institution: t2,
    name
  } = creditCardOffer;
  const {
    applyLink,
    applyPhoneNumber,
    isActive,
    isMonetizing,
    reviewLink,
    termsFeesLink
  } = t1;
  const {
    name: institutionName
  } = t2;
  const t3 = `learn-more-small-apply-now-${creditCardOffer.id}`;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      paddingY: 0.75,
      minHeight: "30px",
      paddingX: 0
    };
    $[0] = t4;
  } else {
    t4 = $[0];
  }
  let t5;
  if ($[1] !== applyLink || $[2] !== applyPhoneNumber || $[3] !== creditCardOffer.details.versionId || $[4] !== ctaAnalytics || $[5] !== institutionName || $[6] !== isActive || $[7] !== isMonetizing || $[8] !== name || $[9] !== reviewLink || $[10] !== t3 || $[11] !== termsFeesLink) {
    t5 = <ApplyNowButton id={t3} isActive={isActive} isMonetizing={isMonetizing} applyLink={applyLink} reviewLink={reviewLink} termsFeesRedirectLink={termsFeesLink} applyPhoneNumber={applyPhoneNumber} institutionName={institutionName} hideIcon={true} analytics={ctaAnalytics} linkSx={t4} versionId={creditCardOffer.details.versionId} name={name} />;
    $[1] = applyLink;
    $[2] = applyPhoneNumber;
    $[3] = creditCardOffer.details.versionId;
    $[4] = ctaAnalytics;
    $[5] = institutionName;
    $[6] = isActive;
    $[7] = isMonetizing;
    $[8] = name;
    $[9] = reviewLink;
    $[10] = t3;
    $[11] = termsFeesLink;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
};